module.exports = __webpack_public_path__ + "img/810400-R.95839a59.jpg";